export enum Authenticity {
    VERIFIED = 1,
    LIKELY = 2
}
export function getAuthenticityString(authenticity: Authenticity) {
    switch (authenticity) {
        case Authenticity.VERIFIED:
            return 'Verified';
        case Authenticity.LIKELY: default:
            return 'Likely';
    }
}